import React from 'react';
import { Link } from 'react-router-dom';
import { Flex, Box } from '@mantine/core';
import { HamburgerMenu } from './partials/HamburgerMenu';
import { LanguageSelect } from './partials/LanguageSelect';
import LogoSrc from '@/assets/images/logo.svg';
import styles from './Navbar.module.scss';

const baseSlug = 'sidebar.';

export const Navbar: React.FC = () => {
	return (
		<Box
			component="nav"
			id="navbar"
			className={styles.navbar}
			px={{ base: 'md', md: 'lg' }}
		>
			<Box miw={175}>
				<Link to="/">
					<img src={LogoSrc} width={175} />
				</Link>
			</Box>
			<Flex
				display={{
					base: 'none',
					md: 'flex',
				}}
				justify="flex-end"
				className="flex-grow-1"
				gap="lg"
			>
				<LanguageSelect />
			</Flex>
			<HamburgerMenu baseSlug={baseSlug} />
		</Box>
	);
};
